import appGlobalScript from '/tmp/scratch/ticom-coveo-components_hCFZx/src/global/coveo-components.ts';
export const globalScripts = appGlobalScript;
